import xhr from '../utils/fetch';

export interface Ticket {
  _id: string;
  description: string;
  email: string;
  phoneNumber: string;
  priority: 'high' | 'medium' | 'low';
  subject: string;
  topic: 'payments' | 'scheduling' | 'technical' | 'general' | 'invoices';
  status?: 'active' | 'in-progress' | 'resolved';
  createdAt: string;
  updatedAt: string;
  fullName: string;
}

export interface TicketFilters {
  priority?: 'high' | 'medium' | 'low';
  status?: 'active' | 'in-progress' | 'resolved';
  topic?: 'payments' | 'scheduling' | 'technical' | 'general' | 'invoices';
  email?: string;
}

// 1. POST /tickets - Create New Ticket
const create = async (ticket: Omit<Ticket, '_id' | 'createdAt' | 'updatedAt'>) => {
  return await xhr({
    url: `/tickets`,
    method: 'POST',
    body: ticket
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

// 2. GET /tickets - Get All Tickets
const get = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
): Promise<{ count: number; data: Ticket[] }> => {
  return await xhr({
    url: `/tickets`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

// Special case for getting single ticket by _id
const getById = async (id: string) => {
  return await xhr({
    url: `/tickets`,
    method: 'GET',
    params: { _id: id }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

// 3. GET /tickets/email/:email - Get Tickets by Email
const getByEmail = async (email: string) => {
  return await xhr({
    url: `/tickets/email/${email}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

// 4. PUT /tickets - Update Ticket
const update = async (ticket: { _id: string; data: Partial<Ticket> }) => {
  return await xhr({
    url: `/tickets`,
    method: 'PUT',
    body: ticket
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

// 5. DELETE /tickets/:_id - Delete Ticket
const deleteTicket = async (id: string) => {
  return await xhr({
    url: `/tickets/${id}`,
    method: 'DELETE'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const ticketsApi = {
  create,
  get,
  getById,
  getByEmail,
  update,
  delete: deleteTicket
};

export default ticketsApi;